import { C } from "../common/component";
import { FormRowType } from "./form-row-type";
import { BooleanEditControl } from "./edit-controls/boolean-edit-control";
import { DateRangeControl } from "./edit-controls/dates/date-range-control";
import { DateControl } from "./edit-controls/dates/date-control";
import { DateTimeControl } from "./edit-controls/dates/date-time-control";
import { InputControl } from "./edit-controls/input-control";
import { SuggestionsEditControl } from "./edit-controls/suggestions-edit-control";
import { TextareaControl } from "./edit-controls/textarea-control";
import { TimeControl } from "./edit-controls/dates/time-control";
import { ViewCellEditControl } from "./edit-controls/view-cell-edit-control";
import { FileEditControl } from "./edit-controls/files/file-edit-control";
import { MultiFileEditControl } from "./edit-controls/files/multi-file-edit-control";
import { SignatureEditControl } from "./edit-controls/signature-edit-control";
import { SeatingPlanEditControl } from "./edit-controls/seating-plan-edit-control";
import { ColorEditControl } from "./edit-controls/color-edit-control";
import { PasswordEditControl } from "./edit-controls/password-edit-control";
import { TranslationsEditControl } from "./edit-controls/translations-edit-control";
import { Icon, IconHelper } from "../common/icon-helper";
import { EditControl } from "./form-row";
import { SelectControl } from "./edit-controls/select-control";
import { TranslatableSuggestionsEditControl } from "./edit-controls/translatable-suggestion-edit-control";
import { MapEditControl } from "../maps/map-edit-control";

export class EditControlBuilder
{
    static create(typeData, unit?, getFieldValue?: (fieldName: string) => string, placeholder?: string,
                  isCompact: boolean = false, triggerMainButton: () => void = null): EditControl
    {
        if (getFieldValue == null)
        {
            getFieldValue = _ => null;
        }
        if (typeData.Type === FormRowType.FilterChoice || typeData.Type === FormRowType.Choice)
        {
            return new SelectControl(typeData.CanSelectMany, typeData.Choices ?? typeData.InitialChoices ?? [], typeData.SearchUrl,
                typeData.ChoicesDisplayValuesUrl, getFieldValue, isCompact, placeholder, typeData.NoInputHeightLimit);
        }
        if (typeData.Type === FormRowType.Suggestions)
        {
            return new SuggestionsEditControl(typeData, getFieldValue);
        }
        if (typeData.Type === FormRowType.TranslatableSuggestions)
        {
            return new TranslatableSuggestionsEditControl(
                typeData.Title,
                typeData.Languages,
                typeData,
                getFieldValue
            );
        }
        if (typeData.Type === FormRowType.Date)
        {
            return new DateControl(placeholder);
        }
        if (typeData.Type === FormRowType.Time)
        {
            return new TimeControl(typeData.Accuracy);
        }
        if (typeData.Type === FormRowType.DateRange)
        {
            return new DateRangeControl(placeholder);
        }
        if (typeData.Type === FormRowType.DateTime)
        {
            return new DateTimeControl(typeData.Accuracy);
        }
        if (typeData.Type === FormRowType.Boolean)
        {
            return new BooleanEditControl(isCompact, typeData.EmptySpaceLeft ?? false);
        }
        if (typeData.Type === FormRowType.Signature)
        {
            return new SignatureEditControl();
        }
        if (typeData.Type === FormRowType.File)
        {
            return new FileEditControl(false);
        }
        if (typeData.Type === FormRowType.UnlimitedFile)
        {
            return new FileEditControl(false, true);
        }
        if (typeData.Type === FormRowType.Files)
        {
            return new MultiFileEditControl();
        }
        if (typeData.Type === FormRowType.Image)
        {
            return new FileEditControl(true);
        }
        if (typeData.Type === FormRowType.Note)
        {
            return new TextareaControl();
        }
        if (typeData.Type === FormRowType.ViewCell)
        {
            return new ViewCellEditControl();
        }
        if (typeData.Type === FormRowType.SeatingPlan)
        {
            return new SeatingPlanEditControl(getFieldValue);
        }
        if (typeData.Type === FormRowType.Color)
        {
            return new ColorEditControl();
        }
        if (typeData.Type === FormRowType.Password)
        {
            return new PasswordEditControl(typeData.TwoInputs);
        }
        if (typeData.Type === FormRowType.Translations)
        {
            return new TranslationsEditControl(typeData.Title, typeData.Languages, typeData.NumberOfTextBoxRows);
        }
        if (typeData.Type === FormRowType.Location)
        {
            return new MapEditControl();
        }
        return new InputControl(typeData.Type, unit, typeData.MinValue, typeData.MaxValue, typeData.TriggerMainButtonOnEnter,
            triggerMainButton);
    }

    static createGroupElement(parent, name, collapseByDefault: boolean)
    {
        const header = C.legend.addClass("group-element clickable").appendTo(parent);
        const container = C.fieldset.appendTo(parent);
        IconHelper.addIconWithText(header, collapseByDefault ? Icon.angleRight : Icon.angleDown, name);
        let shown = !collapseByDefault;
        container.collapse();
        header.click(function ()
        {
            if (shown)
            {
                IconHelper.addIconWithText(header, Icon.angleRight, name);
                container.collapse("hide");
                shown = false;
            }
            else
            {
                IconHelper.addIconWithText(header, Icon.angleDown, name);
                container.collapse("show");
                shown = true;
                // This is hack because collapse("hide") does not work initially for some reason
                container.show();
            }
        });
        if (collapseByDefault)
        {
            // This is hack because collapse("hide") does not work initially for some reason
            container.hide();
        }
        return container;
    }
}
